import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-password-strength',
  templateUrl: './password-strength.component.html',
  styleUrls: ['./password-strength.component.scss']
})
export class PasswordStrengthComponent implements OnInit {

  @Input() score;
  constructor() { }

  ngOnInit() {
  }

  getStrength(){
    if(this.score>20 && this.score<40){
      return "Password Very Weak";
    }else if(this.score>=40 && this.score<70){
      return "Password Weak";
    }else if(this.score>=70 && this.score<90){
      return "Password Good";
    }else if(this.score>=90){
      return "Password Strong";
    }
  }

}
